// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2ds4r","title":"ClientInsurance_title__2XxE-","itemText":"ClientInsurance_itemText__2FazO"};